import { IRequestBody, IResponseBody } from '../types.ts';
import { API_URL } from '../constants/index.ts';
import axios from './network/axios.ts';
class VerifyRequest {
  private static instance: VerifyRequest;
  axiosInstance!: any;
  axiosConfig!: any;
  language?: string;

  baseURL?: any;
  headers?: any;
  data?: any;

  public static getInstance() {
    if (!VerifyRequest.instance) {
      VerifyRequest.instance = new VerifyRequest();
    }
    return VerifyRequest.instance;
  }

  public init(
    axiosInstance: any,
    axiosConfig: any,
    // language: string,
    baseURL: any,
    headers: any,
    data: any
  ) {
    // 接入站外场景 新增逻辑
    this.baseURL = baseURL;
    this.headers = headers;
    this.data = data;

    this.axiosInstance = axiosInstance || axios.create();
    this.axiosConfig = axiosConfig;
  }

  public queryRiskValidationToken(
    payload: IRequestBody
  ): Promise<IResponseBody> {
    if (!this.axiosInstance) {
      throw new Error('Please call VerifyManager.init before making API calls');
    }

    return this.axiosInstance(API_URL.VALIDATION_TOKEN, {
      method: 'POST',
      data: payload,
      headers: { ...this.axiosConfig.headers },
    });
  }

  public queryGeetestRegister(payload: any): Promise<IResponseBody> {
    if (!this.axiosInstance) {
      throw new Error('Please call VerifyManager.init before making API calls');
    }
    return this.axiosInstance(API_URL.GEETEST_REGISTER, {
      method: 'POST',
      data: payload,
      headers: { ...this.axiosConfig.headers },
    });
  }

  public queryResources(payload: any): Promise<IResponseBody> {
    if (!this.axiosInstance)
      throw new Error('Please call VerifyManager.init before making API calls');
    return this.axiosInstance(API_URL.VALIDATION_RESOURCES, {
      method: 'POST',
      data: payload,
    });
  }

  public queryRiskValidationCheck = async (
    payload: IRequestBody
  ): Promise<IResponseBody> => {
    if (!this.axiosInstance)
      throw new Error('Please call VerifyManager.init before making API calls');
    return this.axiosInstance(API_URL.VALIDATION_CHECK, {
      method: 'POST',
      data: payload,
      headers: { ...this.axiosConfig.headers },
    });
  };
}

export default VerifyRequest.getInstance();
